import { render, staticRenderFns } from "./whistlist2.vue?vue&type=template&id=9204b7de&"
import script from "./whistlist2.vue?vue&type=script&lang=js&"
export * from "./whistlist2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports